import React, { useState, useEffect } from "react";
import ProjectPropOne from "./itemProp/ProjectPropOne";
import SectionTitle from "../../elements/section-title/SectionTitle";
import SectionTitle2 from "../../elements/section-title2/SectionTitle2";
import ProjectData from "../../data/project/ProjectData.json";
import SmartCardData from "../../data/project/SmartCardData.json";
import SmartTechCard from "./itemProp/SmartTechCard";

const filters = [
  {
    id: 1,
    label: "All Works",
  },
  {
    id: 2,
    label: "Branding",
  },
  {
    id: 3,
    label: "Mobile",
  },
];

const ProjectOne = ({
  parentClass,
  colSize,
  itemShow,
  columnGap,
  title,
  subtitle,
  isHomePage,
  isSmartTech,
}) => {
  const AllData = isSmartTech ? SmartCardData : ProjectData;

  const [getAllItems] = useState(AllData);
  const [visiableProject] = useState(itemShow ? itemShow : 6);
  const [activeFilter, setActiveFilter] = useState("");
  const [visibleItems, setVisibleItems] = useState([]);
  const [paddingStyle, setPaddingStyle] = useState({});

  useEffect(() => {
    setActiveFilter(filters[0].label);
    setVisibleItems(getAllItems.filter((item) => item.id <= visiableProject));

    const updatePadding = () => {
      if (!isHomePage) {
        const isTabletOrBelow = window.innerWidth <= 991;
        setPaddingStyle({
          padding: isTabletOrBelow ? "0px 0px 0px" : "110px 0px 0px",
        });
      }
    };

    updatePadding();
    window.addEventListener("resize", updatePadding);
    return () => window.removeEventListener("resize", updatePadding);
  }, []);

  const handleChange = (e) => {
    e.preventDefault();
    let target = e.target.textContent;

    setActiveFilter(target);

    let tempData = [];
    if (target === filters[0].label) {
      tempData = getAllItems.filter((data) => data.id <= visiableProject);
    } else {
      for (let i = 0; i < getAllItems.length; i++) {
        const element = getAllItems[i];
        let categories = element["category"];

        if (categories.includes(target)) {
          tempData.push(element);
        }
      }
    }
    setVisibleItems(tempData);
  };

  return (
    <>
      <div
        className={`section ${isHomePage ? "section-padding-2" : ""} ${
          parentClass ? parentClass : ""
        }`}
        style={!isHomePage ? paddingStyle : {}}
      >
        <div className="container">
          <SectionTitle2 
            SectionTitle2
            subtitle={subtitle}
            title={title}
            textAlignment="heading-left mb--40"
            textColor=""
          />

          <div className={`row ${columnGap ? columnGap : "row-35"}`}>
            {/* {visibleItems.map((data) => ( */}
            {AllData.slice(0, 8).map((data) => (
              <div className={colSize ? colSize : "col-md-6"} key={data.id}>
                {isSmartTech ? (
                  <SmartTechCard
                    projectStyle=""
                    portfolio={data}
                    isHomePage={isHomePage}
                  />
                ) : (
                  <ProjectPropOne
                    projectStyle=""
                    portfolio={data}
                    isHomePage={isHomePage}
                  />
                )}
                {/* <ProjectPropOne projectStyle="" portfolio={data} isHomePage={isHomePage}/> */}
                {/* <ProjectPropOne projectStyle="" portfolio={data} /> */}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default ProjectOne;
